export default __webpack_public_path__ + "static/media/seller.7e049e69.jpg";